import { render, staticRenderFns } from "./CopTiposGestion.vue?vue&type=template&id=8521aa4a&scoped=true"
import script from "./CopTiposGestion.vue?vue&type=script&lang=js"
export * from "./CopTiposGestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8521aa4a",
  null
  
)

export default component.exports